export default __webpack_public_path__ + "static/media/pcp-guide-chart-1.0f1a6f4f.svg";